<div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Carregando dados...</p>
</div>

<div class="main-container" *ngIf="!toggle && !isLoading">
    <div class="close-background" (click)="onToggleClick($event)"></div>
    <div class="table-container" (click)="$event.stopPropagation()">
        <div class="table-header">
            <h2 class="title">MILK RUN</h2>
        </div>

        <div class="division"></div>
        <div class="scrollable-table">

            <table class="table">
                <thead>
                    <tr>
                        <th>Registro</th>
                        <th>Transportadora</th>
                        <th>Fornecedores</th>
                        <th>Placa</th>
                        <th>Área</th>
                        <th>Janela</th>
                        <th>Ação</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let trip of data">
                        <td>{{trip.Sequencia}}</td>
                        <td>{{trip.Transportadora}}</td>
                        <td>{{trip.Fornecedores}}</td>
                        <td>{{trip.Plate}}</td>
                        <td>{{trip.Area}}</td>
                        <td>{{trip.Janela | date:'dd/MM/yyyy HH:mm'}}</td>
                        <td>
                            <button class="link" (click)="onSelectRow(trip, $event)">
                                <fa-icon [icon]="faCheck"></fa-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>